var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassarPaginaVersaoEsquerdaClara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0, 0, 0, 0)",
    fillRule: "evenodd",
    d: "M11.5 0C17.84702278 0 23 5.15297722 23 11.5S17.84702278 23 11.5 23 0 17.84702278 0 11.5 5.15297722 0 11.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M12.68622808 17.50000246l1.34317853-1.4099985-4.3629384-4.5900049 4.36294871-4.5899951-1.34317536-1.4100015-5.71565332 5.99999358 5.71563984 6.00000642z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassarPaginaVersaoEsquerdaClara);
export default __webpack_public_path__ + "static/media/passar_pagina_versao_esquerda_clara.cb331f8b86538cd100061db5227ead33.svg";
export { ForwardRef as ReactComponent };